import {useEffect} from "react";
import {useWhatInputIsLastPointerMouse} from "../what-input/useWhatInput";

const className = "is-last-input-mouse";
const useRegulateWhatInputClassNames = () => {
  const isLastInputMouse = useWhatInputIsLastPointerMouse();

  useEffect(() => {
    const bodyClassList = document.documentElement.classList;

    if (isLastInputMouse) {
      bodyClassList.add(className);
    } else {
      bodyClassList.remove(className);
    }
  }, [isLastInputMouse]);
};

export default useRegulateWhatInputClassNames;
